const LT_COUNTRY_CODE = 'LT'
const LT_PERSONAL_ID_LENGTH = 11
const LT_MIN_AGE = 18

const digitsRegex = /^\d+$/

const centuryMap = {
  1: '18',
  2: '18',
  3: '19',
  4: '19',
  5: '20',
  6: '20',
}

export const validatePersonalIdNumber =
  (nationalityCode: string) =>
  (personalId: string): { isValid: boolean; isValidAge: boolean } => {
    if (nationalityCode.toUpperCase() !== LT_COUNTRY_CODE)
      return { isValid: true, isValidAge: true }
    if (personalId.length !== LT_PERSONAL_ID_LENGTH) return { isValid: false, isValidAge: false }
    if (!digitsRegex.test(personalId)) return { isValid: false, isValidAge: false }

    const century = centuryMap[Number(personalId[0])]

    if (!century) return { isValid: false, isValidAge: false }

    const year = Number(century + personalId.slice(1, 3))
    const month = Number(personalId.slice(3, 5))
    const day = Number(personalId.slice(5, 7))

    if (month < 1 || month > 12) return { isValid: false, isValidAge: false }
    if (day < 1 || day > 31) return { isValid: false, isValidAge: false }

    const birthDate = new Date(year, month - 1, day)

    // Make sure date exists. Example 29th of February
    if (
      birthDate.getFullYear() !== year ||
      birthDate.getMonth() !== month - 1 ||
      birthDate.getDate() !== day
    ) {
      return { isValid: false, isValidAge: false }
    }

    const today = new Date()
    const age = today.getFullYear() - birthDate.getFullYear()

    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      return { isValid: true, isValidAge: age - 1 >= LT_MIN_AGE }
    }

    return { isValid: true, isValidAge: age >= LT_MIN_AGE }
  }
